// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__PmzrB","label":"Labeled_label__1AF9T","divider":"Labeled_divider__7MsP7"};